import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "others-view-h5"
};
import PagesHeaderH5 from "@/components/h5/common/pagesHeaderH5.vue";
import { computed, onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
export default {
  __name: 'OthresViewH5',
  setup(__props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      allowType: ['thread', 'thread-only-reply', 'draft', 'follow', 'follower', 'notice'],
      nnn: 0,
      tabs: {
        'rule': {
          val: 'rule',
          txt: '社区规则'
        },
        'privacy': {
          val: 'privacy',
          txt: '隐私说明'
        },
        'aboutus': {
          val: 'aboutus',
          txt: '关于我们'
        },
        'appdownload': {
          val: 'appdownload',
          txt: 'APP下载'
        }
      }
    });
    const tabs = computed(() => {
      return state.tabs;
    });
    onMounted(() => {
      window.scrollTo(0, 0);
      store.commit('forum/setSelectedForum', '');
    });
    router.beforeEach((to, from, next) => {
      window.scrollTo(0, 0);
      next();
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(PagesHeaderH5, {
        class: "h5-view-header fixed-item -header",
        title: _ctx.$route.meta.name,
        backTo: 'others.php'
      }, null, 8, ["title", "backTo"]), _createVNode(_component_router_view)]);
    };
  }
};